import { Navigate, Route, Routes } from "react-router-dom";

import ChangeHospitalContainer from "../ChangeHospitalContainer/ChangeHospitalContainer";
import EditProfileContainer from "../EditProfileContainer/EditProfileContainer";
import { PAGES_PATH } from "../../../navigation/params";
import PaymentRoutingContainer from "../PaymentRoutingContainer/PaymentRoutingContainer";
import React from "react";
// eslint-disable-next-line max-len
import UserDetailsContainer from "../UserDetailsContainer/UserDetailsContainer";
import { PastPetsContainer } from "..";

export interface IUserRoutingProps {
  setTitle: (data: string) => void;
  setOnBack: (data: boolean) => void;
}

// TODO: Move this file to Routing during cleanup

const UserRoutingContainer = () => {
  return (
    <Routes>
      <Route path={PAGES_PATH.EDIT_PROFILE} element={<EditProfileContainer />} />
      <Route path={`${PAGES_PATH.USER_BILLING}/*`}
        element={<PaymentRoutingContainer />} />
      <Route path={PAGES_PATH.CHANGE_HOSPITAL} element={<ChangeHospitalContainer />} />
      <Route path={PAGES_PATH.PAST_PETS} element={<PastPetsContainer />} />

      <Route path="/" element={<UserDetailsContainer />} />
      <Route path={"*"} element={<Navigate replace to={PAGES_PATH.USER_PROFILE}/>} />

    </Routes>
  );
};

export default UserRoutingContainer;
